/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_4_TitleInputs */

const en_mk_tb_step_4_title = /** @type {(inputs: Mk_Tb_Step_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow the whole project`)
};

const id_mk_tb_step_4_title = /** @type {(inputs: Mk_Tb_Step_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantau seluruh proyek`)
};

/**
* | output |
* | --- |
* | "Follow the whole project" |
*
* @param {Mk_Tb_Step_4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_4_title = /** @type {((inputs?: Mk_Tb_Step_4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_4_title(inputs)
	return en_mk_tb_step_4_title(inputs)
});